import { useLazyImageToPromptQuery } from '../../../services/agrocraftArtisan';
import { useRef } from 'react';
import addPhotoAlternateLogo from '../../../assets/icons/add_photo_alternate.svg';
import './index.scss';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';
import { getLanguage } from '../../../components/languageSelect/helpers/functions';

type TProps = {
  setPrompt: React.Dispatch<React.SetStateAction<string>>;
  setIsLoadingImageToPrompt: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

export const ImageToPrompt = ({
  setPrompt,
  setIsLoadingImageToPrompt,
}: TProps) => {
  const hiddenFileInput = useRef<HTMLInputElement | null>(
    null
  );
  const [imageToPrompt] = useLazyImageToPromptQuery();

  const handleImageToPrompt = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (
      event.currentTarget.files &&
      event.currentTarget.files.length > 0
    ) {
      const fileUploaded = event.currentTarget.files[0];
      const data = new FormData();
      data.append('image', fileUploaded);
      appLogEvent(CUSTOM_EVENTS.IMAGE_TO_PROMPT, {
        language: getLanguage(),
      });
      setIsLoadingImageToPrompt(true);
      imageToPrompt(data)
        .then((res) => {
          const prompt = res.data?.prompt;
          prompt && setPrompt(prompt);
        })
        .finally(() => {
          setIsLoadingImageToPrompt(false);
        });
    }
  };

  const handleUploadBtnClick = () => {
    hiddenFileInput?.current?.click();
  };

  return (
    <div className="image-to-prompt-container">
      <div
        onClick={handleUploadBtnClick}
        className="image-to-prompt_btn">
        <img src={addPhotoAlternateLogo} />
        <span>Image to Prompt</span>
      </div>
      <input
        type="file"
        style={{ display: 'none' }}
        ref={hiddenFileInput}
        onChange={(e) => {
          handleImageToPrompt(e);
        }}
        accept=".jpg,.jpeg,.png"
      />
    </div>
  );
};
